module.exports = __webpack_public_path__ + "static/img/30020 (3).3a185ef.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30020 (3).webp
// module id = 7NWx
// module chunks = 14